import { render } from "./NotFound.vue?vue&type=template&id=e692e21c&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=e692e21c&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e692e21c"]])

export default __exports__